import {Messages} from "../../Messages";
import {SubscribeFlowController} from "./SubscribeFlowController";
import {startGiftSubscriptionFlow} from "./startFlow";
import {iFrameState} from "../../services/IFrameState";


export class GiftSubscriptionFlowController extends SubscribeFlowController {
    actionButtonTestId = "giftSubscriptionBtn";
    actionButtonDefaultAnid = "gift-subscription-button";
    logInFooterDefaultAnid = "gift-subscription-login-footer";

    onClickAuthenticated() {
        startGiftSubscriptionFlow();
    }

    onClickNotAuthenticated() {
        startGiftSubscriptionFlow();
    }

    getHeaderDefaultText() {
        return iFrameState.panelText || Messages.giftSubscriptionWall;
    }

    onLoginClick() {
        startGiftSubscriptionFlow(false, true);
    }

    getActionButtonDefaultLabel() {
        return iFrameState.panelButtonText || Messages.giftSubscription;
    }

    getLoginFooterMessage() {
        return Messages.alreadyHaveAnAccount;
    }
}
